import React from 'react';
import { getAbsolutePlayerTime, getPreviousSegmentAbsoluteTime, getSegmentAtCurrentFrame } from '../timeUtils';
import useAddChapterItem from '../hooks/useAddChapterItem';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import Icon from '@/components/atoms/Icon';
import { useRemotionPlayerCurrentTime } from '@/App/remotion/MainPlayer/ClipPlayerV2WithNewTimeline/hooks/useRemotionPlayerCurrentTime';
import { isSplitsInTimelineEnabled } from '@/stores/clip';

export default function AddChapterButton() {
  const { clipData, fps } = useClipsContext();
  const { currentTime } = useRemotionPlayerCurrentTime();
  const addChapter = useAddChapterItem();
  const isDisabled = addChapter?.isDisabled ?? true;
  const onClick = addChapter?.onClick;

  const currentSegment = getSegmentAtCurrentFrame(currentTime, clipData);
  const cuePointPosition =
    getAbsolutePlayerTime(currentTime, clipData) * fps -
    (isSplitsInTimelineEnabled(clipData) || !currentSegment
      ? 0
      : getPreviousSegmentAbsoluteTime(currentSegment, clipData) * fps);

  if (isDisabled) {
    return null;
  }

  return (
    <button
      className="absolute top-1/2 z-[25] -translate-y-1/2 opacity-0 hover:opacity-100"
      onClick={e => {
        e.stopPropagation();
        onClick?.();
      }}
      style={{ left: `calc(${cuePointPosition}px * var(--timeline-zoom))` }}
    >
      <div className="z-[200] flex size-5 -translate-x-1/2 items-center justify-center rounded-full bg-black shadow-md">
        <Icon name="IconPlus" className="size-3 text-white" />
      </div>
    </button>
  );
}
